import Navbar from '../components/Navbar';
import { ArrowLeft, Shield } from 'lucide-react';
import { Link } from 'react-router-dom';

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      
      <div className="container-app py-12">
        <Link to="/" className="inline-flex items-center text-sage-600 hover:text-sage-700 mb-8">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Retour à l'accueil
        </Link>
        
        <div className="max-w-4xl mx-auto bg-white rounded-2xl p-8 md:p-12 shadow-soft">
          <div className="flex items-center gap-4 mb-8">
            <div className="w-14 h-14 bg-sage-100 rounded-xl flex items-center justify-center">
              <Shield className="w-7 h-7 text-sage-600" />
            </div>
            <h1 className="font-heading text-3xl md:text-4xl font-semibold text-foreground">
              Politique de Confidentialité
            </h1>
          </div>
          
          <p className="text-muted-foreground mb-8">
            Dernière mise à jour : Décembre 2024
          </p>
          
          <div className="bg-sage-50 border border-sage-200 rounded-xl p-6 mb-8">
            <p className="text-sage-700">
              Chez Opora Vie, la protection de vos données personnelles est une priorité. 
              Cette politique explique comment nous collectons, utilisons et protégeons vos informations 
              conformément au Règlement Général sur la Protection des Données (RGPD).
            </p>
          </div>
          
          <div className="prose prose-sage max-w-none">
            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">1. Responsable du traitement</h2>
            <p className="text-muted-foreground mb-4">
              Le responsable du traitement des données est Opora Vie, accessible à l'adresse apora.net.
              <br />Contact : <a href="mailto:contact@apora.net" className="text-sage-600">contact@apora.net</a>
            </p>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">2. Données collectées</h2>
            <p className="text-muted-foreground mb-4">
              Nous collectons les données suivantes :
            </p>
            
            <h3 className="font-heading text-lg font-medium text-foreground mt-6 mb-3">Pour les Clients :</h3>
            <ul className="list-disc pl-6 text-muted-foreground mb-4 space-y-2">
              <li>Nom et prénom</li>
              <li>Adresse email</li>
              <li>Numéro de téléphone (optionnel)</li>
              <li>Historique des rendez-vous</li>
              <li>Données de paiement (traitées par Stripe)</li>
            </ul>
            
            <h3 className="font-heading text-lg font-medium text-foreground mt-6 mb-3">Pour les Praticiens :</h3>
            <ul className="list-disc pl-6 text-muted-foreground mb-4 space-y-2">
              <li>Informations d'identité complètes</li>
              <li>Qualifications professionnelles</li>
              <li>Photo de profil</li>
              <li>Coordonnées professionnelles</li>
              <li>Informations bancaires (pour les paiements via Stripe Connect)</li>
            </ul>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">3. Finalités du traitement</h2>
            <p className="text-muted-foreground mb-4">
              Vos données sont utilisées pour :
            </p>
            <ul className="list-disc pl-6 text-muted-foreground mb-4 space-y-2">
              <li>Créer et gérer votre compte utilisateur</li>
              <li>Permettre la mise en relation entre Clients et Praticiens</li>
              <li>Traiter les réservations et paiements</li>
              <li>Envoyer des confirmations et rappels de rendez-vous</li>
              <li>Améliorer nos services</li>
              <li>Assurer la sécurité de la plateforme</li>
              <li>Respecter nos obligations légales</li>
            </ul>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">4. Base légale</h2>
            <p className="text-muted-foreground mb-4">
              Le traitement de vos données repose sur :
            </p>
            <ul className="list-disc pl-6 text-muted-foreground mb-4 space-y-2">
              <li><strong>Exécution du contrat :</strong> pour fournir nos services</li>
              <li><strong>Consentement :</strong> pour les communications marketing (avec possibilité de retrait)</li>
              <li><strong>Intérêt légitime :</strong> pour améliorer nos services et assurer la sécurité</li>
              <li><strong>Obligation légale :</strong> pour les données fiscales et comptables</li>
            </ul>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">5. Durée de conservation</h2>
            <p className="text-muted-foreground mb-4">
              Vos données sont conservées :
            </p>
            <ul className="list-disc pl-6 text-muted-foreground mb-4 space-y-2">
              <li>Compte actif : pendant toute la durée de votre inscription</li>
              <li>Compte supprimé : 3 ans après suppression (obligations légales)</li>
              <li>Données de facturation : 10 ans (obligations comptables)</li>
              <li>Cookies : 13 mois maximum</li>
            </ul>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">6. Partage des données</h2>
            <p className="text-muted-foreground mb-4">
              Vos données peuvent être partagées avec :
            </p>
            <ul className="list-disc pl-6 text-muted-foreground mb-4 space-y-2">
              <li><strong>Les Praticiens/Clients :</strong> informations nécessaires à la consultation</li>
              <li><strong>Stripe :</strong> pour le traitement des paiements</li>
              <li><strong>Hébergeur :</strong> pour le stockage sécurisé des données</li>
              <li><strong>Autorités compétentes :</strong> si requis par la loi</li>
            </ul>
            <p className="text-muted-foreground mb-4">
              Nous ne vendons jamais vos données à des tiers.
            </p>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">7. Sécurité des données</h2>
            <p className="text-muted-foreground mb-4">
              Nous mettons en œuvre des mesures de sécurité appropriées :
            </p>
            <ul className="list-disc pl-6 text-muted-foreground mb-4 space-y-2">
              <li>Chiffrement SSL/TLS pour toutes les communications</li>
              <li>Mots de passe hashés avec des algorithmes sécurisés</li>
              <li>Accès restreint aux données personnelles</li>
              <li>Sauvegardes régulières et sécurisées</li>
              <li>Surveillance continue des systèmes</li>
            </ul>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">8. Vos droits</h2>
            <p className="text-muted-foreground mb-4">
              Conformément au RGPD, vous disposez des droits suivants :
            </p>
            <ul className="list-disc pl-6 text-muted-foreground mb-4 space-y-2">
              <li><strong>Droit d'accès :</strong> obtenir une copie de vos données</li>
              <li><strong>Droit de rectification :</strong> corriger vos données inexactes</li>
              <li><strong>Droit à l'effacement :</strong> demander la suppression de vos données</li>
              <li><strong>Droit à la portabilité :</strong> recevoir vos données dans un format structuré</li>
              <li><strong>Droit d'opposition :</strong> vous opposer au traitement de vos données</li>
              <li><strong>Droit à la limitation :</strong> restreindre le traitement de vos données</li>
            </ul>
            <p className="text-muted-foreground mb-4">
              Pour exercer ces droits, contactez-nous à : 
              <a href="mailto:contact@apora.net" className="text-sage-600"> contact@apora.net</a>
            </p>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">9. Cookies</h2>
            <p className="text-muted-foreground mb-4">
              Notre site utilise des cookies pour :
            </p>
            <ul className="list-disc pl-6 text-muted-foreground mb-4 space-y-2">
              <li>Assurer le bon fonctionnement du site (cookies essentiels)</li>
              <li>Mémoriser vos préférences (langue, session)</li>
              <li>Analyser l'utilisation du site (cookies analytiques)</li>
            </ul>
            <p className="text-muted-foreground mb-4">
              Vous pouvez gérer vos préférences de cookies dans les paramètres de votre navigateur.
            </p>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">10. Données de santé</h2>
            <p className="text-muted-foreground mb-4">
              Opora Vie ne collecte pas directement de données de santé. Les échanges entre Clients et 
              Praticiens lors des consultations sont confidentiels et relèvent de la responsabilité 
              du Praticien, soumis au secret professionnel.
            </p>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">11. Transfert de données</h2>
            <p className="text-muted-foreground mb-4">
              Vos données sont hébergées au sein de l'Union Européenne. En cas de transfert vers des 
              pays tiers, nous nous assurons que des garanties appropriées sont en place (clauses 
              contractuelles types, certifications).
            </p>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">12. Réclamation</h2>
            <p className="text-muted-foreground mb-4">
              Si vous estimez que vos droits ne sont pas respectés, vous pouvez déposer une réclamation 
              auprès de la CNIL (Commission Nationale de l'Informatique et des Libertés) : 
              <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" className="text-sage-600"> www.cnil.fr</a>
            </p>

            <h2 className="font-heading text-xl font-semibold text-foreground mt-8 mb-4">13. Modification de la politique</h2>
            <p className="text-muted-foreground mb-4">
              Cette politique peut être mise à jour. Nous vous informerons de toute modification 
              substantielle par email ou notification sur la plateforme.
            </p>
          </div>
        </div>
      </div>
      
      {/* Footer */}
      <footer className="py-8 bg-foreground text-white mt-12">
        <div className="container-app text-center">
          <p className="text-sand-300 text-sm">
            © 2024 Opora Vie. Tous droits réservés.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default PrivacyPage;
